// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Tbqm","rootSuccess":"CompleteLink_rootSuccess__1E3Bz","rootFailure":"CompleteLink_rootFailure__2uV3w","isDisabled":"CompleteLink_isDisabled__3bgbL"};